import React from 'react';
import { Link } from 'react-router-dom';
import { LOGO_URL, PRODUCT_NAME, STORE_URL } from '../constants/site';
export function Footer() {
  return <footer className="w-full border-t border-slate-200 bg-slate-50" data-id="element-47">
      <div className="mx-auto max-w-6xl px-4 py-12 sm:px-6" data-id="element-48">
        <div className="flex flex-col gap-8 sm:flex-row sm:items-start sm:justify-between" data-id="element-49">
          <div className="max-w-sm" data-id="element-50">
            <div className="flex items-center gap-2" data-id="element-51">
              <span className="flex h-8 w-8 items-center justify-center overflow-hidden rounded-lg border border-slate-200 bg-white" data-id="element-52">
                <img src={LOGO_URL} alt="" className="h-6 w-6 object-contain" data-id="element-53" />
              </span>
              <span className="text-base font-bold text-slate-900" data-id="element-54">
                {PRODUCT_NAME}
              </span>
            </div>
            <p className="mt-3 text-sm leading-relaxed text-slate-500" data-id="element-55">
              Capture selected X posts and replies as one clean PNG. Local-only,
              privacy-first.
            </p>
          </div>

          <div className="flex flex-wrap gap-x-12 gap-y-6" data-id="element-56">
            <div data-id="element-57">
              <h3 className="text-xs font-semibold uppercase tracking-wide text-slate-400" data-id="element-58">
                Product
              </h3>
              <ul className="mt-3 space-y-2 text-sm" data-id="element-59">
                <li data-id="element-60">
                  <a href="/#features" className="text-slate-600 hover:text-slate-900" data-id="element-61">
                    Features
                  </a>
                </li>
                <li data-id="element-62">
                  <a href="/#how" className="text-slate-600 hover:text-slate-900" data-id="element-63">
                    How it works
                  </a>
                </li>
                <li data-id="element-64">
                  <a href="/#faq" className="text-slate-600 hover:text-slate-900" data-id="element-65">
                    FAQ
                  </a>
                </li>
                <li data-id="element-66">
                  <a href={STORE_URL} target="_blank" rel="noopener noreferrer" className="text-slate-600 hover:text-slate-900" data-id="element-67">
                    Chrome Web Store
                  </a>
                </li>
              </ul>
            </div>
            <div data-id="element-68">
              <h3 className="text-xs font-semibold uppercase tracking-wide text-slate-400" data-id="element-69">
                Legal
              </h3>
              <ul className="mt-3 space-y-2 text-sm" data-id="element-70">
                <li data-id="element-71">
                  <Link to="/privacy" className="text-slate-600 hover:text-slate-900" data-id="element-72">
                    Privacy Policy
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-10 border-t border-slate-200 pt-6" data-id="element-73">
          <p className="text-xs leading-relaxed text-slate-400" data-id="element-74">
            {PRODUCT_NAME} is an independent project and is not affiliated with,
            endorsed by, or sponsored by X Corp. “X”, “Twitter”, the X logo and
            the Twitter bird are trademarks of X Corp. ©{' '}
            {new Date().getFullYear()} {PRODUCT_NAME}.
          </p>
        </div>
      </div>
    </footer>;
}